module.exports = __webpack_public_path__ + "img/booking-online.1e727693.png";